// extracted by mini-css-extract-plugin
export default {"reportsListTableWrapper":"ReportsListTable_reportsListTableWrapper__fcxph","tableContainer":"ReportsListTable_tableContainer__lXQMj","table":"ReportsListTable_table__eZRJ+"};